import React, { useEffect, useState } from 'react';
import { MailIcon, MapPinIcon, LinkedinIcon, XIcon } from 'lucide-react';
import { AnimatePresence, motion } from 'framer-motion';
function PrivacyPolicyModal({
  onClose
}: {
  onClose: () => void;
}) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-228">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} transition={{
      duration: 0.3
    }} className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-229">
        {/* Header */}
        <div className="flex items-center justify-between px-8 py-5 border-b border-gray-200 shrink-0" data-id="element-230">
          <h2 className="text-xl font-heading font-bold text-brand-navy" data-id="element-231">
            Política de Privacidad y Protección de Datos
          </h2>
          <button onClick={onClose} className="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors cursor-pointer border-none" aria-label="Cerrar" data-id="element-232">
            <XIcon className="w-5 h-5 text-gray-600" data-id="element-233" />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto px-8 py-6 text-gray-700 text-sm leading-relaxed space-y-6" data-id="element-234">
          <section data-id="element-235">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-236">
              1. INTRODUCCIÓN
            </h3>
            <p data-id="element-237">
              En REDORG valoramos y respetamos la privacidad de nuestros
              usuarios. Esta Política de Privacidad describe cómo recopilamos,
              utilizamos, almacenamos y protegemos los datos personales que
              usted nos proporciona al utilizar nuestros sitios, APPs,
              terminales de autoatención u otros sistemas o canales de
              comunicación.
            </p>
          </section>

          <section data-id="element-238">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-239">
              2. RESPONSABLE DEL TRATAMIENTO
            </h3>
            <ul className="space-y-1 ml-1" data-id="element-240">
              <li data-id="element-241">
                <strong data-id="element-242">Nombre de la entidad:</strong> Fundación REDORG
              </li>
              <li data-id="element-243">
                <strong data-id="element-244">Dirección Legal:</strong> Edificio The Point, Oficina
                1803, Puerto Santa Ana, Guayaquil, Ecuador.
              </li>
              <li data-id="element-245">
                <strong data-id="element-246">Correo electrónico de contacto:</strong>{' '}
                protecciondatos@redorg.net
              </li>
            </ul>
          </section>

          <section data-id="element-247">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-248">
              3. DATOS PERSONALES QUE RECOPILAMOS
            </h3>
            <p className="mb-2" data-id="element-249">
              Podemos recopilar los siguientes datos personales cuando navegas o
              interactúas con nuestro sitio web u otros canales:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-250">
              <li data-id="element-251">Nombres y apellidos</li>
              <li data-id="element-252">Número de Cédula</li>
              <li data-id="element-253">Correo electrónico</li>
              <li data-id="element-254">Número de teléfono</li>
              <li data-id="element-255">
                Dirección IP y datos de navegación (cookies, ubicación, tipo de
                navegador)
              </li>
              <li data-id="element-256">
                Información proporcionada mediante formularios de contacto o
                suscripción
              </li>
            </ul>
          </section>

          <section data-id="element-257">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-258">
              4. FINALIDAD DEL TRATAMIENTO
            </h3>
            <p className="mb-2" data-id="element-259">
              Recopilamos tus datos con las siguientes finalidades:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-260">
              <li data-id="element-261">
                Enviar información institucional, boletines, eventos, productos
                y servicios
              </li>
              <li data-id="element-262">
                Atender consultas o solicitudes realizadas a través de
                formularios de contacto
              </li>
              <li data-id="element-263">Gestionar inscripciones a eventos o programas</li>
              <li data-id="element-264">
                Gestionar promociones, beneficios, sistemas de fidelización y
                otras actividades de marketing
              </li>
              <li data-id="element-265">
                Realizar análisis estadísticos de navegación (uso de cookies)
              </li>
              <li data-id="element-266">Cumplir con obligaciones legales y regulatorias</li>
            </ul>
          </section>

          <section data-id="element-267">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-268">
              5. LEGITIMACIÓN PARA EL TRATAMIENTO
            </h3>
            <p className="mb-2" data-id="element-269">
              El tratamiento de tus datos se realiza con base en:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-270">
              <li data-id="element-271">Tu consentimiento expreso</li>
              <li data-id="element-272">
                El interés legítimo de REDORG para cumplir su misión
                institucional
              </li>
              <li data-id="element-273">
                El cumplimiento de obligaciones legales, según la normativa
                ecuatoriana aplicable (Ley Orgánica de Protección de Datos
                Personales – LOPDP)
              </li>
            </ul>
          </section>

          <section data-id="element-274">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-275">
              6. DESTINATARIOS DE LOS DATOS
            </h3>
            <p className="mb-2" data-id="element-276">
              Tus datos personales no serán compartidos con terceros, salvo que:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-277">
              <li data-id="element-278">Tengamos tu consentimiento previo</li>
              <li data-id="element-279">Sea requerido por autoridad competente conforme a la ley</li>
              <li data-id="element-280">
                Se usen herramientas tecnológicas de terceros (por ejemplo, para
                envío de newsletters, CRM o formularios) con contratos que
                garantizan la protección de tus datos
              </li>
            </ul>
          </section>

          <section data-id="element-281">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-282">
              7. DERECHOS DEL TITULAR DE LOS DATOS
            </h3>
            <p className="mb-2" data-id="element-283">Tienes derecho a:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-284">
              <li data-id="element-285">Acceder a tus datos personales</li>
              <li data-id="element-286">Rectificar datos inexactos o incompletos</li>
              <li data-id="element-287">Eliminar tus datos (cuando proceda)</li>
              <li data-id="element-288">Oponerte al tratamiento</li>
              <li data-id="element-289">Solicitar la portabilidad de tus datos</li>
              <li data-id="element-290">Revocar el consentimiento en cualquier momento</li>
            </ul>
            <p className="mt-2" data-id="element-291">
              Puedes ejercer estos derechos escribiéndonos a{' '}
              <a href="mailto:protecciondatos@redorg.net" className="text-brand-royal underline hover:text-brand-navy transition-colors" data-id="element-292">
                protecciondatos@redorg.net
              </a>
            </p>
          </section>

          <section data-id="element-293">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-294">
              8. USO DE COOKIES
            </h3>
            <p data-id="element-295">
              Nuestros sitios utilizan cookies propias y de terceros para
              mejorar la experiencia de navegación y análisis del tráfico.
              Puedes aceptar, configurar o rechazar el uso de cookies desde el
              banner de consentimiento al ingresar al sitio.
            </p>
          </section>

          <section data-id="element-296">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-297">
              9. SEGURIDAD DE LA INFORMACIÓN
            </h3>
            <p data-id="element-298">
              REDORG aplica medidas de seguridad técnicas y organizativas
              adecuadas para proteger tus datos personales contra accesos no
              autorizados, pérdida, destrucción o alteración.
            </p>
          </section>

          <section data-id="element-299">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-300">
              10. CONSERVACIÓN DE LOS DATOS
            </h3>
            <p data-id="element-301">
              Tus datos serán conservados solo durante el tiempo necesario para
              cumplir con la finalidad para la que fueron recopilados o mientras
              exista una relación institucional o contractual. Posteriormente
              serán eliminados o anonimizados, según corresponda.
            </p>
          </section>

          <section data-id="element-302">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-303">
              11. CAMBIOS A ESTA POLÍTICA
            </h3>
            <p data-id="element-304">
              Nos reservamos el derecho de modificar esta Política de Privacidad
              en cualquier momento. Cualquier cambio será publicado con la fecha
              de actualización correspondiente.
            </p>
          </section>

          <section data-id="element-305">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-306">
              12. AUTORIDAD DE CONTROL
            </h3>
            <p data-id="element-307">
              Si consideras que tus derechos no han sido respetados, puedes
              presentar un reclamo ante la Autoridad de Protección de Datos
              Personales de Ecuador, la Superintendencia de Protección de Datos
              Personales.
            </p>
          </section>

          <section data-id="element-308">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-309">
              13. VIGENCIA
            </h3>
            <p data-id="element-310">
              La vigencia de estas Políticas de Privacidad y Protección de Datos
              es desde el 20 de marzo de 2026 y permanecerá vigente hasta que
              exista una nueva versión que la reemplace.
            </p>
          </section>
        </div>
      </motion.div>
    </motion.div>;
}
function TermsModal({
  onClose
}: {
  onClose: () => void;
}) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-311">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} transition={{
      duration: 0.3
    }} className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-312">
        {/* Header */}
        <div className="flex items-center justify-between px-8 py-5 border-b border-gray-200 shrink-0" data-id="element-313">
          <h2 className="text-xl font-heading font-bold text-brand-navy" data-id="element-314">
            Términos y Condiciones de Uso Plataformas REDORG
          </h2>
          <button onClick={onClose} className="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors cursor-pointer border-none" aria-label="Cerrar" data-id="element-315">
            <XIcon className="w-5 h-5 text-gray-600" data-id="element-316" />
          </button>
        </div>

        {/* Content */}
        <div className="overflow-y-auto px-8 py-6 text-gray-700 text-sm leading-relaxed space-y-6" data-id="element-317">
          <section data-id="element-318">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-319">
              1. ACEPTACIÓN DE LOS TÉRMINOS
            </h3>
            <p data-id="element-320">
              Al acceder, navegar, registrarse o utilizar el sitio web,
              aplicación móvil o cualquier plataforma digital oficial de
              Fundación REDORG (en adelante nombrados como la "Plataforma" y
              "REDORG" respectivamente), el usuario declara haber leído,
              entendido y aceptado íntegramente los presentes Términos y
              Condiciones, así como la Política de Privacidad vigente.
            </p>
            <p className="mt-2" data-id="element-321">
              Si el usuario no está de acuerdo con estos Términos, deberá
              abstenerse de utilizar la Plataforma.
            </p>
          </section>

          <section data-id="element-322">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-323">
              2. IDENTIFICACIÓN DEL TITULAR
            </h3>
            <p data-id="element-324">
              La Plataforma es operada por REDORG, entidad sin fines de lucro
              constituida conforme a las leyes de la República del Ecuador.
            </p>
          </section>

          <section data-id="element-325">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-326">
              3. USUARIOS
            </h3>
            <p className="mb-2" data-id="element-327">Pueden utilizar la Plataforma:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-328">
              <li data-id="element-329">Personas naturales mayores de 18 años</li>
              <li data-id="element-330">
                Menores de edad bajo la responsabilidad expresa de su padre,
                madre o representante legal, especialmente en el caso de
                escuelas deportivas
              </li>
            </ul>
            <p className="mt-2" data-id="element-331">
              El usuario es responsable de la veracidad de la información
              proporcionada durante su registro.
            </p>
          </section>

          <section data-id="element-332">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-333">
              4. SERVICIOS OFRECIDOS
            </h3>
            <p className="mb-2" data-id="element-334">La Plataforma permite, entre otros:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-335">
              <li data-id="element-336">
                Administración de organizaciones, aliados, socios y adherentes.
              </li>
              <li data-id="element-337">Administración y venta de productos y servicios.</li>
              <li data-id="element-338">
                Inscripción para eventos, capacitaciones, actividades u otros.
              </li>
              <li data-id="element-339">
                Pago de mensualidades, matrículas y otros valores relacionados
                con productos y servicios.
              </li>
              <li data-id="element-340">Acceso a contenido informativo, promocional y multimedia.</li>
              <li data-id="element-341">Otros productos y servicios.</li>
            </ul>
            <p className="mt-2" data-id="element-342">
              REDORG se reserva el derecho de modificar, suspender o eliminar
              servicios sin previo aviso.
            </p>
          </section>

          <section data-id="element-343">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-344">
              5. REGISTRO Y CUENTAS
            </h3>
            <p className="mb-2" data-id="element-345">
              Para acceder a ciertos servicios, el usuario deberá crear una
              cuenta proporcionando información veraz y actualizada.
            </p>
            <p className="mb-2" data-id="element-346">El usuario es responsable de:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-347">
              <li data-id="element-348">Mantener la confidencialidad de su usuario y contraseña.</li>
              <li data-id="element-349">Todas las actividades realizadas desde su cuenta.</li>
            </ul>
            <p className="mt-2" data-id="element-350">
              REDORG no será responsable por el uso no autorizado de cuentas por
              negligencia del usuario.
            </p>
          </section>

          <section data-id="element-351">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-352">
              6. CONDICIONES DE VENTA – PRODUCTOS Y SERVICIOS
            </h3>
            <ul className="list-disc ml-6 space-y-1" data-id="element-353">
              <li data-id="element-354">
                Los productos y servicios están sujetos a disponibilidad de
                stock.
              </li>
              <li data-id="element-355">
                Los precios incluyen los impuestos aplicables conforme a la ley
                ecuatoriana.
              </li>
              <li data-id="element-356">
                Las imágenes son referenciales; pueden existir variaciones
                mínimas.
              </li>
              <li data-id="element-357">
                Cambios o devoluciones solo se aceptarán por defectos de
                fabricación o falta de prestación de servicio, conforme a la
                política vigente.
              </li>
            </ul>
            <p className="mt-2" data-id="element-358">
              REDORG no se responsabiliza por retrasos atribuibles a terceros
              (courier, fuerza mayor, etc.).
            </p>
          </section>

          <section data-id="element-359">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-360">
              7. PAGOS Y TRANSACCIONES
            </h3>
            <ul className="list-disc ml-6 space-y-1" data-id="element-361">
              <li data-id="element-362">
                Todos los pagos se procesan a través de plataformas seguras de
                terceros.
              </li>
              <li data-id="element-363">REDORG no almacena información bancaria sensible.</li>
              <li data-id="element-364">
                El usuario autoriza el débito de los valores correspondientes a
                los productos y servicios adquiridos.
              </li>
            </ul>
            <p className="mt-2" data-id="element-365">
              Cualquier reclamo deberá realizarse dentro de los plazos
              establecidos por la ley.
            </p>
          </section>

          <section data-id="element-366">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-367">
              8. PROPIEDAD INTELECTUAL
            </h3>
            <p data-id="element-368">
              Todo el contenido de la Plataforma (logos, escudos, textos,
              imágenes, videos, diseños, marcas y software) es propiedad
              exclusiva de REDORG o de terceros autorizados.
            </p>
            <p className="mt-2" data-id="element-369">
              Queda prohibida su reproducción, distribución o uso comercial sin
              autorización expresa y por escrito.
            </p>
          </section>

          <section data-id="element-370">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-371">
              9. USO PROHIBIDO
            </h3>
            <p className="mb-2" data-id="element-372">El usuario se compromete a no:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-373">
              <li data-id="element-374">Utilizar la Plataforma con fines ilícitos.</li>
              <li data-id="element-375">Realizar fraudes o suplantación de identidad.</li>
              <li data-id="element-376">Introducir virus, malware o códigos dañinos.</li>
              <li data-id="element-377">Afectar el funcionamiento de la Plataforma.</li>
            </ul>
            <p className="mt-2" data-id="element-378">
              El incumplimiento podrá resultar en la suspensión o cancelación
              inmediata de la cuenta.
            </p>
          </section>

          <section data-id="element-379">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-380">
              10. RESPONSABILIDAD Y LIMITACIONES
            </h3>
            <p className="mb-2" data-id="element-381">REDORG no garantiza:</p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-382">
              <li data-id="element-383">Disponibilidad ininterrumpida de la Plataforma.</li>
              <li data-id="element-384">Ausencia total de errores técnicos.</li>
            </ul>
            <p className="mt-2" data-id="element-385">
              El uso de la Plataforma se realiza bajo responsabilidad exclusiva
              del usuario.
            </p>
          </section>

          <section data-id="element-386">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-387">
              11. PROTECCIÓN DE DATOS PERSONALES
            </h3>
            <p data-id="element-388">
              El tratamiento de los datos personales se rige por la Política de
              Privacidad de REDORG y la normativa vigente en Ecuador.
            </p>
          </section>

          <section data-id="element-389">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-390">
              12. VIGENCIA Y MODIFICACIONES
            </h3>
            <p data-id="element-391">REDORG podrá modificar estos Términos en cualquier momento.</p>
            <p className="mt-2" data-id="element-392">
              La vigencia de estos Términos y Condiciones de Uso es desde el 20
              de marzo de 2026 y permanecerá vigente hasta que exista una nueva
              versión que la reemplace.
            </p>
          </section>

          <section data-id="element-393">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-394">
              13. LEGISLACIÓN Y JURISDICCIÓN
            </h3>
            <p data-id="element-395">
              Estos Términos se rigen por las leyes de la República del Ecuador.
            </p>
            <p className="mt-2" data-id="element-396">
              Cualquier controversia será sometida a los jueces competentes de
              la ciudad de Guayaquil.
            </p>
          </section>

          <section data-id="element-397">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-398">
              14. CONTACTO
            </h3>
            <p data-id="element-399">
              Para consultas o reclamos, el usuario puede comunicarse a través
              de los canales oficiales de REDORG disponibles en la Plataforma.
            </p>
          </section>
        </div>
      </motion.div>
    </motion.div>;
}
function CookiesModal({
  onClose
}: {
  onClose: () => void;
}) {
  useEffect(() => {
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = '';
    };
  }, []);
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} exit={{
    opacity: 0
  }} className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={onClose} data-id="element-400">
      <motion.div initial={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} animate={{
      opacity: 1,
      scale: 1,
      y: 0
    }} exit={{
      opacity: 0,
      scale: 0.95,
      y: 20
    }} transition={{
      duration: 0.3
    }} className="bg-white rounded-2xl shadow-2xl max-w-3xl w-full max-h-[85vh] flex flex-col overflow-hidden" onClick={e => e.stopPropagation()} data-id="element-401">
        <div className="flex items-center justify-between px-8 py-5 border-b border-gray-200 shrink-0" data-id="element-402">
          <h2 className="text-xl font-heading font-bold text-brand-navy" data-id="element-403">
            Política de Cookies
          </h2>
          <button onClick={onClose} className="w-9 h-9 rounded-full bg-gray-100 hover:bg-gray-200 flex items-center justify-center transition-colors cursor-pointer border-none" aria-label="Cerrar" data-id="element-404">
            <XIcon className="w-5 h-5 text-gray-600" data-id="element-405" />
          </button>
        </div>

        <div className="overflow-y-auto px-8 py-6 text-gray-700 text-sm leading-relaxed space-y-6" data-id="element-406">
          <section data-id="element-407">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-408">
              1. INTRODUCCIÓN
            </h3>
            <p data-id="element-409">
              En REDORG utilizamos cookies y tecnologías similares para mejorar
              la experiencia de navegación en nuestros sitios web, analizar el
              tráfico, personalizar el contenido y mostrar anuncios relevantes.
              A continuación, te explicamos qué son las cookies, cómo las usamos
              y cómo puedes gestionarlas.
            </p>
          </section>

          <section data-id="element-410">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-411">
              2. ¿QUÉ SON LAS COOKIES?
            </h3>
            <p data-id="element-412">
              Las cookies son pequeños archivos de texto que un sitio web
              almacena en tu dispositivo (computadora, celular o tablet) al
              visitarlo. Estas permiten que el sitio "recuerde" tus acciones o
              preferencias (como idioma, inicio de sesión, etc.) durante un
              período de tiempo determinado.
            </p>
          </section>

          <section data-id="element-413">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-414">
              3. ¿QUÉ TIPOS DE COOKIES UTILIZAMOS?
            </h3>
            <h4 className="font-heading font-semibold text-brand-navy text-sm mt-3 mb-1" data-id="element-415">
              A. Cookies necesarias (técnicas):
            </h4>
            <p data-id="element-416">
              Permiten la navegación en el sitio web y el uso de sus funciones
              esenciales. Sin estas cookies, el sitio no puede funcionar
              correctamente.
            </p>
            <h4 className="font-heading font-semibold text-brand-navy text-sm mt-3 mb-1" data-id="element-417">
              B. Cookies de preferencia o personalización:
            </h4>
            <p data-id="element-418">
              Almacenan información para que el usuario acceda al servicio con
              características personalizadas, como el idioma o región.
            </p>
            <h4 className="font-heading font-semibold text-brand-navy text-sm mt-3 mb-1" data-id="element-419">
              C. Cookies de análisis o rendimiento:
            </h4>
            <p data-id="element-420">
              Nos permiten conocer el comportamiento de los visitantes para
              mejorar el sitio. Usamos herramientas como Google Analytics u
              otras similares.
            </p>
            <h4 className="font-heading font-semibold text-brand-navy text-sm mt-3 mb-1" data-id="element-421">
              D. Cookies de publicidad o marketing:
            </h4>
            <p data-id="element-422">
              Recopilan información sobre tus hábitos de navegación para
              mostrarte anuncios relevantes en nuestros sitios o en otros.
            </p>
          </section>

          <section data-id="element-423">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-424">
              4. ¿CUÁNTO TIEMPO PERMANECEN ACTIVAS?
            </h3>
            <ul className="list-disc ml-6 space-y-1" data-id="element-425">
              <li data-id="element-426">
                <strong data-id="element-427">Cookies de sesión:</strong> se eliminan al cerrar el
                navegador.
              </li>
              <li data-id="element-428">
                <strong data-id="element-429">Cookies persistentes:</strong> permanecen en tu
                dispositivo hasta que las elimines o expiren.
              </li>
            </ul>
          </section>

          <section data-id="element-430">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-431">
              5. ¿CÓMO PUEDES CONTROLAR LAS COOKIES?
            </h3>
            <p className="mb-2" data-id="element-432">
              Al ingresar por primera vez a nuestro sitio, se te mostrará un
              aviso de cookies. Puedes aceptar todas, rechazarlas o
              configurarlas según tu preferencia.
            </p>
            <p className="mb-2" data-id="element-433">
              Además, puedes modificar la configuración de cookies desde tu
              navegador en cualquier momento:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-434">
              <li data-id="element-435">Google Chrome: Configuración de cookies</li>
              <li data-id="element-436">Mozilla Firefox: Administrar cookies</li>
              <li data-id="element-437">Safari: Soporte de Safari</li>
              <li data-id="element-438">Microsoft Edge: Privacidad y servicios</li>
            </ul>
          </section>

          <section data-id="element-439">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-440">
              6. COOKIES DE TERCEROS
            </h3>
            <p className="mb-2" data-id="element-441">
              Algunas cookies pueden ser instaladas por servicios de terceros
              utilizados en nuestro sitio (como redes sociales, plataformas de
              video, servicios de estadísticas, etc.). No tenemos control
              directo sobre ellas. Te recomendamos revisar sus respectivas
              políticas:
            </p>
            <ul className="list-disc ml-6 space-y-1" data-id="element-442">
              <li data-id="element-443">Google: Política de privacidad</li>
              <li data-id="element-444">Meta (Facebook / Instagram): Política de cookies</li>
            </ul>
          </section>

          <section data-id="element-445">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-446">
              7. CAMBIOS EN ESTA POLÍTICA
            </h3>
            <p data-id="element-447">
              Podemos actualizar esta Política de Cookies en cualquier momento.
              Te notificaremos en nuestro sitio web cuando se hagan cambios
              relevantes.
            </p>
          </section>

          <section data-id="element-448">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-449">
              8. CONTACTO
            </h3>
            <p data-id="element-450">
              Si tienes dudas sobre nuestra política de cookies, puedes
              escribirnos a:{' '}
              <a href="mailto:protecciondatos@redorg.net" className="text-brand-royal underline hover:text-brand-navy transition-colors" data-id="element-451">
                protecciondatos@redorg.net
              </a>
            </p>
          </section>

          <section data-id="element-452">
            <h3 className="font-heading font-bold text-brand-navy text-base mb-2" data-id="element-453">
              9. VIGENCIA
            </h3>
            <p data-id="element-454">
              La vigencia de estas Políticas es desde el 20 de marzo de 2026 y
              permanecerá vigente hasta que exista una nueva versión que la
              reemplace.
            </p>
          </section>
        </div>
      </motion.div>
    </motion.div>;
}
export function Footer() {
  const currentYear = new Date().getFullYear();
  const [showPrivacy, setShowPrivacy] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [showCookies, setShowCookies] = useState(false);
  return <>
      <footer className="bg-brand-navy pt-20 pb-10 border-t border-white/10" data-id="element-455">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-456">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 mb-16" data-id="element-457">
            {/* Brand Column */}
            <div data-id="element-458">
              <div className="bg-white inline-block p-2 rounded-lg mb-6" data-id="element-459">
                <img src="https://cdn.magicpatterns.com/uploads/78sjHca3jZk8xTuZahNMSg/Logo_REDORG.png" alt="RedOrg Logo" className="h-12 w-auto object-contain" data-id="element-460" />
              </div>
              <p className="text-white/70 mb-6 leading-relaxed" data-id="element-461">
                Uniendo fuerzas por Ecuador. Apoyamos a organizaciones sin fines
                de lucro para multiplicar el impacto social.
              </p>
              <div className="flex gap-4" data-id="element-462">
                <a href="https://www.linkedin.com/company/redorgecuador/" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center text-white hover:bg-brand-gold hover:text-brand-navy transition-colors" data-id="element-463">
                  <LinkedinIcon className="w-5 h-5" data-id="element-464" />
                </a>
              </div>
            </div>

            {/* Contact Column */}
            <div data-id="element-465">
              <h4 className="text-white font-heading font-semibold text-lg mb-6" data-id="element-466">
                Contacto
              </h4>
              <div className="space-y-4" data-id="element-467">
                <div className="flex items-start gap-3 text-white/70" data-id="element-468">
                  <MapPinIcon className="w-5 h-5 text-brand-gold shrink-0 mt-1" data-id="element-469" />
                  <p data-id="element-470">
                    Edificio The Point, Puerto Santa Ana, Guayaquil, Guayas,
                    Ecuador
                  </p>
                </div>
                <div className="flex items-center gap-3 text-white/70" data-id="element-471">
                  <MailIcon className="w-5 h-5 text-brand-gold shrink-0" data-id="element-472" />
                  <a href="mailto:contacto@redorg.net" className="hover:text-white transition-colors" data-id="element-473">
                    contacto@redorg.net
                  </a>
                </div>
              </div>
            </div>
          </div>

          {/* Copyright */}
          <div className="pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-474">
            <p className="text-white/50 text-sm text-center md:text-left" data-id="element-475">
              &copy; {currentYear} Fundación RedOrg. Todos los derechos
              reservados.
            </p>
            <div className="flex gap-6 text-sm text-white/50" data-id="element-476">
              <button onClick={() => setShowTerms(true)} className="hover:text-white transition-colors bg-transparent border-none cursor-pointer text-white/50 text-sm" data-id="element-477">
                Términos de Uso
              </button>
              <button onClick={() => setShowPrivacy(true)} className="hover:text-white transition-colors bg-transparent border-none cursor-pointer text-white/50 text-sm" data-id="element-478">
                Política de Privacidad y Protección de Datos
              </button>
              <button onClick={() => setShowCookies(true)} className="hover:text-white transition-colors bg-transparent border-none cursor-pointer text-white/50 text-sm" data-id="element-479">
                Cookies
              </button>
            </div>
          </div>
        </div>
      </footer>

      <AnimatePresence data-id="element-480">
        {showPrivacy && <PrivacyPolicyModal onClose={() => setShowPrivacy(false)} data-id="element-481" />}
        {showTerms && <TermsModal onClose={() => setShowTerms(false)} data-id="element-482" />}
        {showCookies && <CookiesModal onClose={() => setShowCookies(false)} data-id="element-483" />}
      </AnimatePresence>
    </>;
}